import React from 'react';
import PropTypes from 'prop-types';

const LoginOverlay = (props) => {
    const { contextCls } = props;

    return <div className={`${contextCls}`} />;
};

LoginOverlay.defaultProps = {};

LoginOverlay.propTypes = {
    contextCls: PropTypes.string,
};

export default LoginOverlay;
